import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeft } from 'lucide-react';

/**
 * Shared layout for legal/info pages.
 * Children render the page body. Title is shown above.
 */
const LegalPageLayout = ({ title, eyebrow, children, testid }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <main className="flex-1 pt-24 pb-16" data-testid={testid}>
        <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-stone-500 hover:text-violet-900 transition-colors text-sm mb-6"
            data-testid="legal-back-link"
          >
            <ArrowLeft size={14} />
            Nazaj na Val Dotika
          </Link>

          {eyebrow && (
            <p className="text-violet-900 text-xs font-semibold tracking-[0.18em] uppercase mb-3">{eyebrow}</p>
          )}
          <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-stone-800 font-bold mb-8" data-testid="legal-title">
            {title}
          </h1>

          <div className="prose prose-stone max-w-none text-stone-700 leading-relaxed space-y-5">
            {children}
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPageLayout;
